import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data, Editors } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, Breadcrumb, ButtonToolbar } from 'react-bootstrap';

import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../Widgets/spinner';
import GenericDatePicker from '../Common/GenericDatePicker';
import { convertTimeToUtc, convertLocalDate } from '../Common/cleanDates';
import { __GAPI_KEY__ } from '../Common/keys';
import SpinnerButton from '../Common/SpinnerButton';
import PrintIframe from '../Common/PrintIframe';
import DispatchMap from './DispatchMap';
import { 
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isLAP, isSUN, isLMH, isSDR, isCRW,
} from '../../actions/root_url';
import { SkyLightStateless } from 'react-skylight';
import GenericSelection from '../Common/GenericSelection';

const isEcity = ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/"|| ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === "https://dev-scm.truckxi.com/api/";

const {
  Draggable: { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer },
  Data: { Selectors },
} = require('react-data-grid-addons');

const { DropDownEditor } = Editors;

const RowRenderer = DropTargetRowContainer(ReactDataGrid.Row);

const propTypes = {
  rowKey: PropTypes.string,
  value: PropTypes.node,
  stopsIsLoading: PropTypes.bool,
  routesIsLoading: PropTypes.bool,
  savingStopEdits: PropTypes.bool,
  routingPdfFailure: PropTypes.bool,
  assigningOrderRoute: PropTypes.bool,
  requestingRoutingPdf: PropTypes.bool,
  pickingListPdfFailure: PropTypes.bool,
  packingListPdfFailure: PropTypes.bool,
  salesInvoicePdfFailure: PropTypes.bool,
  requestingPickingListPdf: PropTypes.bool,
  requestingPackingListPdf: PropTypes.bool,
  unassignedOrdersIsLoading: PropTypes.bool,
  requestingDispatchSalesInvoicePdf: PropTypes.bool,
  routesError: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.bool,
  ]),
  stopsError: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.bool,
  ]),
  unassignedOrdersError: PropTypes.shape({}),
  routes: PropTypes.arrayOf(PropTypes.object),
  stops: PropTypes.shape({
    Active: PropTypes.arrayOf(PropTypes.shape({
      ActiveStopNum: PropTypes.number,
      City: PropTypes.string,
      CustomerNum: PropTypes.string,
      Description: PropTypes.string,
      IsActive: PropTypes.bool,
      Name: PropTypes.string,
    })),
    DriverLocation: PropTypes.string,
    Inactive: PropTypes.arrayOf(PropTypes.shape({
      // Same as active
      StopNum: PropTypes.number,
    })),
    Warehouse: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  }),
  dependentValues: PropTypes.shape({
    TempDate: PropTypes.string,
  }),
  unassignedOrders: PropTypes.arrayOf(PropTypes.shape({})),
  routingPdf: PropTypes.shape({}),
  pickingListPdf: PropTypes.shape({}),
  packingListPdf: PropTypes.shape({}),
  dispatchSalesInvoicePdf: PropTypes.shape({}),
  remove: PropTypes.func,
  fetchStops: PropTypes.func,
  fetchRoutes: PropTypes.func,
  saveEditedStops: PropTypes.func,
  assignOrderRoute: PropTypes.func,
  printDispatchRoute: PropTypes.func,
  fetchUnassignedOrders: PropTypes.func,
  printDispatchPickingList: PropTypes.func,
  printDispatchPackingList: PropTypes.func,
  printDispatchSalesInvoice: PropTypes.func,
};

const defaultProps = {
  value: null,
  rowKey: 'ActiveStopNum',
  stopsIsLoading: false,
  routesIsLoading: false,
  savingStopEdits: false,
  routingPdfFailure: false,
  assigningOrderRoute: false,
  requestingRoutingPdf: false,
  pickingListPdfFailure: false,
  packingListPdfFailure: false,
  salesInvoicePdfFailure: false,
  requestingPickingListPdf: false,
  requestingPackingListPdf: false,
  unassignedOrdersIsLoading: false,
  requestingDispatchSalesInvoicePdf: false,
  stopsError: {},
  routesError: {},
  routes: [],
  stops: {},
  dependentValues: {},
  unassignedOrders: [],
  routingPdf: {},
  pickingListPdf: {},
  packingListPdf: {},
  unassignedOrdersError: {},
  dispatchSalesInvoicePdf: {},
  remove: () => {},
  fetchStops: () => {},
  fetchRoutes: () => {},
  saveEditedStops: () => {},
  assignOrderRoute: () => {},
  printDispatchRoute: () => {},
  fetchUnassignedOrders: () => {},
  printDispatchPickingList: () => {},
  printDispatchPackingList: () => {},
  printDispatchSalesInvoice: () => {},
};

const contextTypes = {
  router: PropTypes.shape({}),
};

class Routing extends Component {
  constructor() {
    super();
    this.state = {
      routeOptions: [],
      routeOptions2: [],

      routes: {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      },
      activeStops: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },
      inactiveStops: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },

      assignedCount: 0,
      unassignedCount: 0,

      routeVisibility: false,
      selectedRoute: '',
      selectedTime: '',
      refresh: false,
      orders: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
        filters: null,
        filteredRows: [],
        selectedRow: null,
        editedRows: [],
        selectedRows: [],
      },
      deliveryDateChosen: new Date(),
      dispatchRouteId: null,
      tabKey: 1,
      routePdfFrameLoaded: true,
      pickingListPdfFrameLoaded: true,
      packingListPdfFrameLoaded: true,
      salesInvoicePdfFrameLoaded: true,

      showGoogleMaps: false,
      centerCoordinates: {
        lat: 34.019733,
        lng: -117.958672,
      },
    };

    this.setDeliveryDate = this.setDeliveryDate.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.routeIFrameIsLoaded = this.routeIFrameIsLoaded.bind(this);
    this.pickingListIFrameIsLoaded = this.pickingListIFrameIsLoaded.bind(this);
    this.packingListIFrameIsLoaded = this.packingListIFrameIsLoaded.bind(this);
    this.salesInvoiceIFrameIsLoaded = this.salesInvoiceIFrameIsLoaded.bind(this);
    this.removeRow = this.removeRow.bind(this);
  }

  componentDidMount() {
    this.props.fetchRoutes(this.state.deliveryDateChosen);
    this.props.fetchUnassignedOrders(this.state.deliveryDateChosen);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.routes && nextProps.routes !== this.props.routes) {
      const newRoutes = _.cloneDeep(nextProps.routes);
      let dispatchRouteId;
      if (newRoutes.length > 0) {
        dispatchRouteId = newRoutes[0].DispatchRoute_id;
        newRoutes[0].isSelected = true;
      }
      const routes = {
        ...this.state.routes,
        rows: newRoutes,
        selectedRows: [newRoutes[0]],
      };
      this.setState({ routes, dispatchRouteId }, () => {
        this.props.fetchStops(routes.rows[0].RouteNum, this.state.deliveryDateChosen, this.props.selectedWarehouse.value);
      });
    }

    if (nextProps.stops && nextProps.stops.Warehouse && nextProps.stops.Warehouse !== this.props.stops.Warehouse) {
      const centerCoordinates = nextProps.stops.Warehouse;
      this.setState({ centerCoordinates });
    }

    if (nextProps.stops && nextProps.stops.Active && nextProps.stops.Active !== this.props.stops.Active) {
      const newStops = _.cloneDeep(nextProps.stops.Active);
      const activeStops = { ...this.state.activeStops, rows: newStops };
      this.setState({ activeStops });
      if (isLAP) {
        this.setState({assignedCount: nextProps.stops.TotalActiveCount});
      }
    }

    if (nextProps.stops && nextProps.stops.Inactive && nextProps.stops.Inactive !== this.props.stops.Inactive) {
      const newStops = _.cloneDeep(nextProps.stops.Inactive);
      const inactiveStops = { ...this.state.inactiveStops, rows: newStops };
      this.setState({ inactiveStops });
    }
    
    if ((isSUN || isLMH || isSDR || isCRW) && (this.props.selectedWarehouse !== nextProps.selectedWarehouse && nextProps.selectedWarehouse.value)) {
      this.props.fetchStops(this.state.routes.selectedRows[0].RouteNum, this.state.deliveryDateChosen, this.props.selectedWarehouse.value);
    }

    if (nextProps.unassignedOrders && nextProps.unassignedOrders !== this.props.unassignedOrders) {
      const routeOptions = [''];
      const routeOptions2 = [{label: 'None', value: ''}];
      nextProps.routes.map((route) => {
        routeOptions.push(route.RouteNum);
        routeOptions2.push({label: route.RouteNum, value: route.RouteNum});
      });
      let tempcustnum = [];
      if (isLAP) {
        nextProps.unassignedOrders.map((r) => {
          tempcustnum.push({...r, Deliver_Customer_num: Number(r.Deliver_Customer_num) ? Number(r.Deliver_Customer_num) : r.Deliver_Customer_num});
        });
      }
      const orders = { ...this.state.orders, rows: isLAP ? tempcustnum : nextProps.unassignedOrders.filter(order => {
        if (isEcity) {
          return order.IsMobile
        }
        return true;
      }), };
      this.setState({ orders, routeOptions, routeOptions2 });
      if (isLAP) {
        this.setState({unassignedCount: nextProps.unassignedOrders.length});
      }
    }

    if (nextProps.routingPdf && nextProps.routingPdf !== this.props.routingPdf) {
      this.setState({ routePdfFrameLoaded: false });
    }

    if (nextProps.pickingListPdf && nextProps.pickingListPdf !== this.props.pickingListPdf) {
      this.setState({ pickingListPdfFrameLoaded: false });
    }

    if (nextProps.packingListPdf && nextProps.packingListPdf !== this.props.packingListPdf) {
      this.setState({ packingListPdfFrameLoaded: false });
    }

    if (nextProps.dispatchSalesInvoicePdf && nextProps.dispatchSalesInvoicePdf !== this.props.dispatchSalesInvoicePdf) {
      this.setState({ salesInvoicePdfFrameLoaded: false });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.routePdfFrameLoaded !== this.state.routePdfFrameLoaded && this.state.routePdfFrameLoaded === false) {
      return false;
    }
    if (nextState.pickingListPdfFrameLoaded !== this.state.pickingListPdfFrameLoaded && this.state.pickingListPdfFrameLoaded === false) {
      return false;
    }
    if (nextState.packingListPdfFrameLoaded !== this.state.packingListPdfFrameLoaded && this.state.packingListPdfFrameLoaded === false) {
      return false;
    }
    if (nextState.salesInvoicePdfFrameLoaded !== this.state.salesInvoicePdfFrameLoaded && this.state.salesInvoicePdfFrameLoaded === false) {
      return false;
    }
    return true;
  }

  setDeliveryDate(e) {
    const orders = { ...this.state.orders, editedRows: [] };
    this.setState({
      orders,
      deliveryDateChosen: e,
    }, () => {
      this.props.fetchRoutes(this.state.deliveryDateChosen)
        .then(() => {
          this.props.fetchStops(this.state.routes.rows[0].RouteNum, this.state.deliveryDateChosen, this.props.selectedWarehouse.value);
          this.setState({ dispatchRouteId: this.state.routes.rows[0].DispatchRoute_id });
        });
      this.props.fetchUnassignedOrders(this.state.deliveryDateChosen);
    });
  }

  handleTabSelect(tabKey) {
    this.setState({ tabKey });
  }

  toggleGoogleMaps = () => {
    this.setState({ showGoogleMaps: !this.state.showGoogleMaps });
  }

  removeRow(dependentValues) {
    let rows = [...this.state.activeStops.rows];
    rows = rows.filter((row) => {
      const match = row.ActiveStopNum !== dependentValues.ActiveStopNum;
      return match;
    });
    rows.map((row, index) => {
      row.ActiveStopNum = index + 1;
    });
    const activeStops = { ...this.state.activeStops, rows };
    this.setState({ activeStops });
  }

  saveChanges = () => {
    const {
      routes,
      activeStops,
      deliveryDateChosen,
      dispatchRouteId,
    } = this.state;
    // let editedRows = _.filter(this.state.orders.editedRows, row => (row.RouteNum !== ''));
    // if (editedRows.length < 0 && routes.length < 0) {
    //   return;
    // }
    // editedRows = this.formatDeliveryTime(editedRows);
    // let editedRows = _.filter(this.state.orders.rows, row => (!row.RouteNum || row.RouteNum !== ''));
    // if (editedRows.length < 0 && routes.length < 0) {
    //   return;
    // }
    let editedRows = [];
    this.state.orders.rows.map((r,i) => {
      if (r.RouteNum) {
        editedRows.push(r);
      }
    });
    if (editedRows.length < 0 && routes.length < 0) {
      return;
    }
    editedRows = this.formatDeliveryTime(editedRows);

    const routeNum = this.state.routes.selectedRows[0].RouteNum;
    this.props.saveEditedStops(activeStops.rows, deliveryDateChosen, dispatchRouteId)
      .then(() => {
        this.props.assignOrderRoute(editedRows)
          .then(() => {
            this.props.fetchStops(routeNum, deliveryDateChosen, this.props.selectedWarehouse.value);
            this.props.fetchUnassignedOrders(deliveryDateChosen);
            const orders = { ...this.state.orders, editedRows: [], selectedRows: [] };
            this.setState({ orders });
          });
      });
  }

  formatDeliveryTime = (editedRows) => {
    editedRows.map((row) => {
      if (row.ETADate) {
        const periodOfTheDay = row.ETADate.substr(-2);
        let etaDate = parseInt(row.ETADate, 10);
        if (periodOfTheDay === 'PM' && etaDate !== 12) {
          etaDate = 12 + parseInt(row.ETADate, 10);
        }
        row.ETADate = convertTimeToUtc(etaDate, row.DispatchDate);
      } else {
        // Makes sure empty strings are not passed to backend
        row.ETADate = undefined;
      }
    });
    return editedRows;
  }


  openRoute = () => {
    this.setState({ routeVisibility: true, selectedRoute: '', selectedTime: '' });
  }
  closeRoute = () => {
    this.setState({ routeVisibility: false });
  }
  handleRouteChange = ( target ) => {
    this.setState({
      selectedRoute: target.value,
    })
  }
  handleTimeChange = ( target ) => {
    this.setState({
      selectedTime: target.value,
    })
  }
  onConfirmRoute = () => {
    let {
      selectedRows,
      rows,
    } = this.state.orders;
    let {selectedRoute, selectedTime, orders, refresh} = this.state;

    if (selectedRows && selectedRows.length > 0) {
      selectedRows.map((s,i) => {
        rows.map((r, j) => {
          if (s.SONum === r.SONum) {
            rows[j].RouteNum = selectedRoute;
            rows[j].ETADate = selectedTime;          
          }
        });
      });
    }
    orders.rows = rows;
    refresh = true;
    this.setState({orders, refresh, routeVisibility: false});                
  }

  routeIFrameIsLoaded() {
    this.setState({ routePdfFrameLoaded: true });
  }

  pickingListIFrameIsLoaded() {
    this.setState({ pickingListPdfFrameLoaded: true });
  }

  packingListIFrameIsLoaded() {
    this.setState({ packingListPdfFrameLoaded: true });
  }

  salesInvoiceIFrameIsLoaded() {
    this.setState({ salesInvoicePdfFrameLoaded: true });
  }

  renderPrintRouteIFrame() {
    const { routePdfFrameLoaded } = this.state;
    const { routingPdf } = this.props;
    return (
      <PrintIframe
        id="routePdf"
        loaded={routePdfFrameLoaded}
        name="routePdf"
        onLoad={this.routeIFrameIsLoaded}
        pdf={routingPdf}
        title={<Translate value="print_routing" />}
      />
    );
  }

  renderPrintPickingListIFrame() {
    const { pickingListPdfFrameLoaded } = this.state;
    const { pickingListPdf } = this.props;
    return (
      <PrintIframe
        id="pickingListPdf"
        loaded={pickingListPdfFrameLoaded}
        name="pickingListPdf"
        onLoad={this.pickingListIFrameIsLoaded}
        pdf={pickingListPdf}
        title={<Translate value="print_picking_list" />}
      />
    );
  }

  renderPrintPackingListIFrame() {
    const { packingListPdfFrameLoaded } = this.state;
    const { packingListPdf } = this.props;
    return (
      <PrintIframe
        id="packingListPdf"
        loaded={packingListPdfFrameLoaded}
        name="packingListPdf"
        onLoad={this.packingListIFrameIsLoaded}
        pdf={packingListPdf}
        title={<Translate value="print_packing_list" />}
      />
    );
  }

  renderPrintSalesInvoiceIFrame() {
    const { salesInvoicePdfFrameLoaded } = this.state;
    const { dispatchSalesInvoicePdf } = this.props;
    return (
      <PrintIframe
        id="dispatchSalesInvoicePdf"
        loaded={salesInvoicePdfFrameLoaded}
        name="dispatchSalesInvoicePdf"
        onLoad={this.salesInvoiceIFrameIsLoaded}
        pdf={dispatchSalesInvoicePdf}
        title={<Translate value="print_si" />}
      />
    );
  }

  renderRoutes() {
    if (this.props.routesIsLoading && !this.props.routesError) {
      return <Spinner />;
    } else if (this.props.routesError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger" id="dispatch-errors">
            { JSON.stringify(this.props.routesError) }
          </div>
        </ContentWrapper>
      );
    }

    const getRows = () => Data.Selectors.getRows(this.state.routes);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const routes = { ...this.state.routes, sortColumn, sortDirection };
      this.setState({ routes });
    };

    const handleRowUpdated = (e) => {
      const rows = this.state.routes.rows.slice(0);
      Object.assign(rows[e.rowIdx], e.updated);
      const routes = { ...this.state.routes, rows };
      this.setState({ routes });
    };

    const onCellSelected = (coordinates) => {
      const newRows = getRows();
      if (this.state.routes.selectedRows[0] === newRows[coordinates.rowIdx]) {
        return;
      }
      newRows.map((r) => {
        r.isSelected = false;
      });
      const selectedRows = [newRows[coordinates.rowIdx]];
      newRows[coordinates.rowIdx].isSelected = true;
      const routes = { ...this.state.routes, rows: newRows, selectedRows };
      this.setState({ routes, dispatchRouteId: newRows[coordinates.rowIdx].DispatchRoute_id }, () => {
        this.props.fetchStops(newRows[coordinates.rowIdx].RouteNum, this.state.deliveryDateChosen, this.props.selectedWarehouse.value);
      });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      const selectedRows = [];
      if (this.state.routes.selectedRows[0] === rows[0]) {
        return;
      }
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row);
      });
      const routes = { ...this.state.routes, rows: newRows, selectedRows };
      this.setState({ routes, dispatchRouteId: rows[0].row.DispatchRoute_id }, () => {
        this.props.fetchStops(rows[0].row.RouteNum, this.state.deliveryDateChosen, this.props.selectedWarehouse.value);
      });
    };

    const columns = [
      {
        key: 'RouteNum',
        name: <Translate value="route_number" />,
        resizable: true,
        filterable: true,
      },
      {
        key: 'DriverName',
        name: <Translate value="driver_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'Vehicle',
        name: <Translate value="vehicle" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'Distance',
        name: <Translate value="distance" />,
        resizable: true,
        sortable: true,
      },
    ];

    return (
      <Row>
        {
          this.state.showGoogleMaps
            ? (
              <DispatchMap
                isMarkerShown={!_.isEmpty(this.state.activeStops.rows)}
                orderPoints={this.state.activeStops.rows}
                driverLocation={this.props.stops.DriverLocation}
                centerCoordinates={this.state.centerCoordinates}
                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${__GAPI_KEY__}&v=3.exp&libraries=geometry,drawing,places`}
                loadingElement={<div style={{ height: '100%' }} />}
                containerElement={<div style={{ height: '300px' }} />}
                mapElement={<div style={{ height: '100%' }} />}
              />
            ) : (
              <Col sm={12}>
                <div id="Routing-dataGrid1">
                  <ReactDataGrid
                    rowKey="DispatchRoute_id"
                    onGridSort={handleGridSort}
                    columns={columns}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    minHeight={295}
                    onRowUpdated={handleRowUpdated}
                    enableRowSelect="single"
                    rowSelection={{
                      showCheckbox: true,
                      onRowsSelected,
                      selectBy: {
                        isSelectedKey: 'isSelected',
                      },
                    }}
                    onCellSelected={onCellSelected}
                  />
                </div>
              </Col>
            )
        }
      </Row>
    );
  }

  renderStops() {
    if (this.props.stopsIsLoading && !this.props.stopsError) {
      return <Spinner />;
    } else if (this.props.stopsError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger" id="dispatch-errors">
            { JSON.stringify(this.props.stopsError) }
          </div>
        </ContentWrapper>
      );
    }

    const getRows = () => Data.Selectors.getRows((this.state.tabKey === 1) ? this.state.activeStops : this.state.inactiveStops);
    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      if (this.state.tabKey === 1) {
        const stops = { ...this.state.activeStops, sortColumn, sortDirection };
        this.setState({ activeStops: stops });
      } else {
        const stops = { ...this.state.inactiveStops, sortColumn, sortDirection };
        this.setState({ inactiveStops: stops });
      }
    };

    const handleRowUpdated = (e) => {
      if (this.state.tabKey === 1) {
        const rows = this.state.activeStops.rows.slice(0);
        Object.assign(rows[e.rowIdx], e.updated);
        const stops = { ...this.state.activeStops, rows };
        this.setState({ activeStops: stops });
      } else {
        const rows = this.state.inactiveStops.rows.slice(0);
        Object.assign(rows[e.rowIdx], e.updated);
        const stops = { ...this.state.inactiveStops, rows };
        this.setState({ inactiveStops: stops });
      }
    };

    const isDraggedRowSelected = (selectedRows, rowDragSource) => {
      if (selectedRows && selectedRows.length > 0) {
        const key = this.props.rowKey;
        return selectedRows.filter(r => r[key] === rowDragSource.data[key]).length > 0;
      }
      return false;
    };

    const reorderRows = (e) => {
      const selectedRows = Selectors.getSelectedRowsByKey({ rowKey: this.props.rowKey, selectedKeys: [], rows: this.state.activeStops.rows });
      const draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
      const undraggedRows = this.state.activeStops.rows.filter(r => draggedRows.indexOf(r) === -1);
      const args = [e.rowTarget.idx, 0].concat(draggedRows);
      Array.prototype.splice.apply(undraggedRows, args);
      undraggedRows.map((row, index) => {
        row.ActiveStopNum = index + 1;
      });
      const activeStops = { ...this.state.activeStops, rows: undraggedRows };
      this.setState({ activeStops });
    };

    const DeleteFormatter = React.createClass({
      render() {
        if (this.props.dependentValues.TempDate) {
          return (
            <span>
              <Button
                bsStyle="danger"
                className="textAlignStyle"
                style={{ height: '23px', width: '39px', padding: '0px' }}
                onClick={() => {
                  this.props.remove(this.props.dependentValues);
                }}
              >X
              </Button>
            </span>
          );
        }
        return <div />;
      },
    });

    const TimeFormatter = React.createClass({
      render() {
        return (this.props.value)
          ? <span>{ convertLocalDate(this.props.value, 'h:mm A') }</span>
          : <span className="label label-danger">-</span>;
      },
    });

    const columns = (this.state.tabKey === 1) ? [
      {
        key: 'Del',
        name: <Translate value="del" />,
        width: 50,
        formatter: <DeleteFormatter remove={this.removeRow} />,
        getRowMetaData: row => row,
      },
      {
        key: 'CustomerNum',
        name: <Translate value="customer" />,
        width: 95,
        resizable: true,
      },
      {
        key: 'Name',
        name: <Translate value="name" />,
        width: 130,
        resizable: true,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        width: 110,
        resizable: true,
      },
      {
        key: 'Address',
        name: <Translate value="address" />,
        width: 280,
        resizable: true,
      },
      {
        key: 'Phone',
        name: <Translate value="phone" />,
        width: 100,
        resizable: true,
      },
      {
        key: 'ETADate',
        name: <Translate value="time" />,
        width: 100,
        resizable: true,
        formatter: TimeFormatter,
      },
      ...isLAP ? [{
        key: "OrderNo",
        name: "SO.",
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="si_no" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Weight",
        name: <Translate value="weight" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
    ] : [],
    ] : [
      {
        key: 'CustomerNum',
        name: <Translate value="customer" />,
        width: 95,
        resizable: true,
      },
      {
        key: 'Name',
        name: <Translate value="name" />,
        width: 130,
        resizable: true,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        width: 110,
        resizable: true,
      },
      {
        key: 'City',
        name: <Translate value="city" />,
        width: 100,
        resizable: true,
      },
      {
        key: 'StopNum',
        name: <Translate value="stop_no" />,
        width: 90,
        resizable: true,
      },
    ];
    if(isLAP) {
      let routeId = {
        key: 'RouteID',
        name: <Translate value="route_id" />,
        width: 95,
        resizable: true,
      };
      if(this.state.tabKey === 1) {
        columns.splice(1,0, routeId);
      } else {
        columns.splice(0,0, routeId);
      }
    }
    if (isSUN) {
      const CustomerNumIdx = _.findIndex(columns, { key: 'CustomerNum' });
      const soCol = {
        key: 'OrderNo',
        name: <Translate value="so_num" />,
        width: 95,
        resizable: true,
      }
      const siCol = {
        key: 'InvoiceNum',
        name: <Translate value="si_num" />,
        width: 95,
        resizable: true,
      }
      columns.splice(CustomerNumIdx, 0, soCol, siCol);
    }

    if (this.state.tabKey === 1) {
      return (
        <Row>
          <Col sm={12}>
            <DraggableContainer>
              <ReactDataGrid
                rowKey={this.props.rowKey}
                onGridSort={handleGridSort}
                rowActionsCell={RowActionsCell}
                columns={columns}
                rowHeight={25}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableRowSelect="single"
                rowRenderer={<RowRenderer onRowDrop={reorderRows} />}
                minHeight={300}
                onRowUpdated={handleRowUpdated}
              />
            </DraggableContainer>
          </Col>
        </Row>
      );
    }
    return (
      <Row>
        <Col sm={12}>
          <div id="Routing-dataGrid2">
            <ReactDataGrid
              rowKey="Product_id"
              onGridSort={handleGridSort}
              columns={columns}
              rowHeight={25}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={300}
              onRowUpdated={handleRowUpdated}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderUnassignedOrders() {
    if (this.props.unassignedOrdersIsLoading && !this.props.unassignedOrdersError) {
      return <Spinner />;
    } else if (this.props.unassignedOrdersError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger" id="dispatch-errors">
            { JSON.stringify(this.props.unassignedOrdersError) }
          </div>
        </ContentWrapper>
      );
    }

    const getRows = () => Data.Selectors.getRows(this.state.orders);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const orders = { ...this.state.orders, sortColumn, sortDirection };
      this.setState({ orders });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      const selectedRows = [...this.state.orders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        // r.row.rowIdx = r.rowIdx;
        selectedRows.push(r.row);
      });
      const orders = {
        ...this.state.orders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ orders });
    };

    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.orders.rows];
      const selectedRows = [...this.state.orders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        const rowIndex = selectedRows.indexOf(r.row);
        selectedRows.splice(rowIndex, 1);
      });
      const orders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ orders });
    };

    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        const rows = getRows();
        rows.map((r) => {
          r.isSelected = false;
        });
        const selectedRows = [rows[rowIdx]];
        rows[rowIdx].isSelected = true;

        const orders = { ...this.state.orders, rows, selectedRows };
        this.setState({ orders });
      }
    };

    const handleFilterChange = (filter) => {
      const filteredRows = [...this.state.orders.rows];
      const newFilters = Object.assign({}, this.state.orders.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const orders = { ...this.state.orders, filters: newFilters, filteredRows };
      this.setState({ orders });
    };

    const onClearFilters = () => {
      // all filters removed
      const orders = { ...this.state.orders, filters: {} };
      this.setState({ orders });
    };

    const handleRowUpdated = (e) => {
      const rows = _.cloneDeep(this.state.orders.rows);
      const editedRows = _.cloneDeep(this.state.orders.editedRows);
      const { filteredRows } = this.state.orders;
      const existingRow = rows[e.rowIdx];
      const indexToRemove = _.findIndex(editedRows, row => row.SONum === existingRow.SONum);
      if (indexToRemove > -1) {
        editedRows.splice(indexToRemove, 1);
      }
      if (filteredRows.length > 0) {
        const index = _.findIndex(rows, ['SONum', filteredRows[e.rowIdx].SONum]);
        Object.assign(rows[index], e.updated);
        editedRows.push(rows[index]);
      } else {
        Object.assign(rows[e.rowIdx], e.updated);
        editedRows.push(rows[e.rowIdx]);
      }
      const orders = { ...this.state.orders, rows, editedRows };
      this.setState({ orders });
    };

    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const timeOptions = [
      '',
      '6:00 AM',
      '7:00 AM',
      '8:00 AM',
      '9:00 AM',
      '10:00 AM',
      '11:00 AM',
      '12:00 PM',
      '1:00 PM',
      '2:00 PM',
      '3:00 PM',
      '4:00 PM',
      '5:00 PM',
      '6:00 PM',
      '7:00 PM',
      '8:00 PM',
    ];

    const onDoubleClick = () => {
      // let {orders} = this.state;
      // orders.selectedRow = [];
      // orders.selectedRow.push(row);
      this.setState({ routeVisibility: true, selectedRoute: '', selectedTime: '' });
    };

    const columns = [
      {
        key: 'SONum',
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        width: 140,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: "100%", height: "100%" }}
            onDoubleClick={() => {
              onDoubleClick();
            }}
          >
            {value}
          </div>
        ),
      },
      {
        key: 'Deliver_Customer_num',
        name: <Translate value="customer_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      ...isLAP ? [{
        key: 'Deliver_CustomerRoute_id',
        name: <Translate value="customer_route_id" />,
        width: 95,
        resizable: true,
        sortable: true,
      }] : [],
      {
        key: 'Deliver_CustomerName',
        name: <Translate value="customer_name" />,
        resizable: true,
        sortable: true,
        width: 220,
        filterable: true,
      },
      {
        key: 'Address',
        name: <Translate value="address" />,
        resizable: true,
        filterable: true,
        sortable: true,
        width: 280,
      },
      {
        key: 'DispatchDate',
        name: <Translate value="scheduled_shipping_date" />,
        resizable: true,
        filterable: false,
        width: 140,
        formatter: DateFormatter,
      },
      {
        key: 'SaleStatus',
        name: <Translate value="Status" />,
        resizable: true,
        filterable: true,
        width: 100,
      },
      {
        key: 'ETADate',
        name: <Translate value="time" />,
        resizable: true,
        // sortable: true,
        filterable: true,
        width: 100,
        // editor: <DropDownEditor options={timeOptions} />,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: "100%", height: "100%" }}
            onDoubleClick={() => {
              onDoubleClick();
            }}
          >
            {value ? value : '-'}
          </div>
        ),
      },
      {
        key: 'RouteNum',
        name: <Translate value="route_number" />,
        resizable: true,
        // sortable: true,
        width: 100,
        // editor: <DropDownEditor options={this.state.routeOptions} />,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: "100%", height: "100%" }}
            onDoubleClick={() => {
              onDoubleClick();
            }}
          >
            {value ? value : '-'}
          </div>
        ),
      },
    ];
    if (isSUN) {
      const customerNoIdx = _.findIndex(columns, { key: 'Deliver_Customer_num' });
      const InvoiceNumCol = {
        key: 'InvoiceNum',
        name: <Translate value="si_num" />,
        resizable: true,
        filterable: true,
        width: 100,
      }
      columns.splice(customerNoIdx, 0, InvoiceNumCol);
    }
    return (
      <Row>
        <Col sm={12}>
          <div id="Routing-dataGrid3">
            <ReactDataGrid
              rowKey="SONum"
              onGridSort={handleGridSort}
              columns={columns}
              headerRowHeight={45}
              enableCellSelect
              onAddFilter={handleFilterChange}
              toolbar={<Toolbar enableFilter />}
              rowHeight={25}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              onRowUpdated={handleRowUpdated}
              onClearFilters={onClearFilters}
              minHeight={280}
              enableRowSelect="multi"
              onRowClick={onRowClick}
              rowSelection={{
                showCheckbox: true,
                enableShiftSelect: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: "isSelected",
                },
              }}
            />
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    const createDialogStyle = {
      width: "500px",
      height: "250px",
      marginLeft: "-15%",
    };
    const timeOptions = [
      {label: 'None', value: ''},
      {label: '6:00 AM', value: '6:00 AM'},
      {label: '7:00 AM', value: '7:00 AM'},
      {label: '8:00 AM', value: '8:00 AM'},
      {label: '9:00 AM', value: '9:00 AM'},
      {label: '10:00 AM', value: '10:00 AM'},
      {label: '11:00 AM', value: '11:00 AM'},
      {label: '12:00 PM', value: '12:00 PM'},
      {label: '1:00 PM', value: '1:00 PM'},
      {label: '2:00 PM', value: '2:00 PM'},
      {label: '3:00 PM', value: '3:00 PM'},
      {label: '4:00 PM', value: '4:00 PM'},
      {label: '5:00 PM', value: '5:00 PM'},
      {label: '6:00 PM', value: '6:00 PM'},
      {label: '7:00 PM', value: '7:00 PM'},
      {label: '8:00 PM', value: '8:00 PM'},
    ];

    let {refresh} = this.state;
    if (refresh) {
        this.setState({refresh:false});
    }

    return (
      //---------------
      // Begin HTML: Create New/Edit routing
      //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="dispatch" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="routing" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar>
          <SpinnerButton
            bsStyle="success"
            onClick={this.saveChanges}
            loading={this.props.savingStopEdits || this.props.assigningOrderRoute}
            icon="fa-save"
            translation={<Translate value="save" />}
            disabled={this.props.savingStopEdits || this.props.assigningOrderRoute}
          />
          <SpinnerButton
            bsStyle="primary"
            onClick={() => this.props.printDispatchRoute(this.state.dispatchRouteId, this.state.deliveryDateChosen)}
            loading={this.props.requestingRoutingPdf && !this.props.routingPdfFailure}
            icon="fa-print"
            translation={<Translate value="print_route" />}
            disabled={(this.props.requestingRoutingPdf && !this.props.routingPdfFailure) || !this.state.dispatchRouteId}
          />
          <SpinnerButton
            bsStyle="primary"
            onClick={() => this.props.printDispatchPickingList(this.state.dispatchRouteId, this.state.deliveryDateChosen)}
            loading={this.props.requestingPickingListPdf && !this.props.pickingListPdfFailure}
            icon="fa-print"
            translation={<Translate value="picking_list" />}
            disabled={(this.props.requestingPickingListPdf && !this.props.pickingListPdfFailure) || !this.state.dispatchRouteId}
          />
          <SpinnerButton
            bsStyle="primary"
            onClick={() => this.props.printDispatchPackingList(this.state.dispatchRouteId, this.state.deliveryDateChosen)}
            loading={this.props.requestingPackingListPdf && !this.props.packingListPdfFailure}
            icon="fa-print"
            translation={<Translate value="packing_list" />}
            disabled={(this.props.requestingPackingListPdf && !this.props.packingListPdfFailure) || !this.state.dispatchRouteId}
          />
          <SpinnerButton
            bsStyle="primary"
            onClick={() => this.props.printDispatchSalesInvoice(this.state.dispatchRouteId, this.state.deliveryDateChosen)}
            loading={this.props.requestingDispatchSalesInvoicePdf && !this.props.salesInvoicePdfFailure}
            icon="fa-print"
            translation={<Translate value="print_si" />}
            disabled={(this.props.requestingDispatchSalesInvoicePdf && !this.props.salesInvoicePdfFailure) || !this.state.dispatchRouteId}
          />
        </ButtonToolbar>
        <GenericDatePicker
          id="routing-date-picker"
          setDate={this.setDeliveryDate}
          selectedDate={this.state.deliveryDateChosen}
        />
        <Grid id="dispatch-routing">
          <Row>
            <Col sm={6}>
              <Panel style={{ height: '350px' }}>
                <Row>
                  <Col sm={6}>
                    <h3><Translate value="route_details" /></h3>
                  </Col>
                  <Button
                    className="toggle-maps-button"
                    bsStyle="primary"
                    onClick={this.toggleGoogleMaps}
                  >
                    <Translate value="toggle_map" />
                  </Button>
                </Row>
                <Row>
                  <Col sm={12}>
                    { this.renderRoutes() }
                  </Col>
                </Row>
              </Panel>
            </Col>
            <Col sm={6}>
              <Tabs
                activeKey={this.state.tabKey}
                justified
                onSelect={this.handleTabSelect}
                className="tabs-panel"
              >
                <Tab eventKey={1} title={<Translate value="active_stops" />}>
                  { this.renderStops() }
                </Tab>
                <Tab eventKey={2} title={<Translate value="default_stops" />}>
                  { this.renderStops() }
                </Tab>
              </Tabs>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Panel style={{ height: '350px' }}>
                <h3 style={{ position: 'absolute', zIndex: '2' }}><Translate value="unassigned_orders" />&nbsp;&nbsp;
                <Button
                    // className="toggle-maps-button"
                    bsStyle="primary"
                    type="button"
                    disabled={!this.state.orders.selectedRows || this.state.orders.selectedRows.length < 1}
                    onClick={() => this.openRoute()}
                    >
                    <Translate value="assign" />
                  </Button>
                  {isLAP &&
                    <span style={{marginLeft: '280px'}}>Assigned: {this.state.assignedCount}</span>
                  }
                  {isLAP &&
                    <span style={{marginLeft: '25px'}}>Unassigned: {this.state.unassignedCount}</span>
                  }
                </h3>
                { !refresh && this.renderUnassignedOrders() }
              </Panel>
            </Col>
          </Row>
          { this.renderPrintRouteIFrame() }
          { this.renderPrintPickingListIFrame() }
          { this.renderPrintPackingListIFrame() }
          { this.renderPrintSalesInvoiceIFrame() }
        </Grid>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.routeVisibility}
          onCloseClicked={() => {
            this.closeRoute();
          }}
          title={<Translate value="set_unassigned_orders" />}
        >
          {/* <br /> */}
          <br />
          <Row className="centerStyle">
            {/* <h4 style={{paddingLeft: '15px', paddingRight: '15px'}}>
              <Translate value="pride_msg_print_shipping" />
            </h4> */}
            <Col sm={2}>
              &nbsp;
              </Col>
            <Col sm={4}>
            <div className="routelap" style={{marginBottom: '20px'}}>
            <GenericSelection
              translation={<Translate value="time" />}
              options={timeOptions}
              value={this.state.selectedTime}
              labelStyle={{ fontSize: '14px'}}
              setSelected={(e) => {this.handleTimeChange(e)}}
            />
            </div>
            </Col>
            <Col sm={4}>
            <div className="routelap" style={{marginBottom: '20px'}}>
             <GenericSelection
              translation={<Translate value="route_number" />}
              options={this.state.routeOptions2}
              value={this.state.selectedRoute}
              // containerStyle={{ width: '100px' }}
              labelStyle={{ fontSize: '14px'}}
              // setSelected={(e) => {
              //   this.setState({ selectedRoute: e.value });
              // }}
              setSelected={(e) => {this.handleRouteChange(e)}}
            />
        </div>
        </Col>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={() => this.closeRoute()}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => this.onConfirmRoute()}
              type="button"
            >
              <Translate value="save" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>



      </ContentWrapper>
    );
  }
}

Routing.propTypes = propTypes;
Routing.defaultProps = defaultProps;
Routing.contextTypes = contextTypes;

export default Routing;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/routing.jsx